import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '~/components/auth-layout';
import { AuthenticatorCodeForm } from '~/components/authenticator-code-form';
import { DocumentRedirect } from '~/components/document-redirect';
import { isSignedIn } from '~/lib/auth-client';
import { DEFAULT_AUTH_REDIRECT, validateAuthSearch } from '~/lib/auth-redirect';

export const Route = createFileRoute('/two-factor')({
  validateSearch: validateAuthSearch,
  beforeLoad: async () => ({ signedIn: await isSignedIn() }),
  component: TwoFactorPage,
});

function TwoFactorPage() {
  const { t } = useTranslation('auth');
  const search = Route.useSearch();
  const { signedIn } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const destination = search.redirect ?? DEFAULT_AUTH_REDIRECT;

  if (signedIn) {
    return <DocumentRedirect to={destination} />;
  }

  return (
    <AuthLayout>
      <div className="flex w-full flex-1 flex-col justify-center gap-5">
        <h1 className="text-2xl font-semibold">
          {t('Two-factor authentication')}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t('Enter the six-digit code from your authenticator app.')}
        </p>
        <AuthenticatorCodeForm
          onVerified={() => {
            window.location.replace(destination);
          }}
          onCancel={() => {
            void navigate({
              to: '/sign-in',
              search,
              replace: true,
              reloadDocument: true,
            });
          }}
          submitLabel={t('Verify')}
          cancelLabel={t('Back to sign-in')}
        />
      </div>
    </AuthLayout>
  );
}
